import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Events from "./pages/Events";
import Registrations from "./pages/Registrations";
import Users from "./pages/Users";
import Settings from "./pages/Settings";
import DeleteAccount from "./pages/DeleteAccount";
import Layout from "./layout/Layout";
import ProtectedRoute from "./components/ProtectedRoute";

const PlaceholderPage = ({ title }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] space-y-4">
    <div className="text-6xl animate-bounce">⚙️</div>
    <h2 className="text-white text-4xl font-black uppercase tracking-tighter">{title}</h2>
    <p className="text-slate-500 font-bold uppercase tracking-widest text-xs">This physical module is under construction</p>
  </div>
);

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Layout><Dashboard /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/events"
          element={
            <ProtectedRoute>
              <Layout><Events /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/registrations"
          element={
            <ProtectedRoute>
              <Layout><Registrations /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <Layout><Users /></Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Layout><Settings /></Layout>
            </ProtectedRoute>
          }
        />
        
        <Route path="/delete-account" element={<DeleteAccount />} />

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}